// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18khM","label":"styles_label__3C2ka"};